<template>
  <label
    class="flex gap-3 items-center"
    :class="[sizeClasses.text, {
      'cursor-pointer': !disabled,
    }]"
  >
    <input
      id="form-editor-customizedform"
      :checked="model"
      type="checkbox"
      class="focus:ring-blue-500 text-blue-600 border-gray-300 rounded-md pointer-events-none"
      :class="sizeClasses.checkbox"
      :disabled="disabled"
      @change="handleChange"
    />
    <span v-if="label">
      {{ label }}
    </span>
  </label>
</template>

<script>
const sizeList = ["sm", "md", "lg"];
const sizeClassMap = {
  sm: {
    text: "text-xs",
    checkbox: "w-4 h-4",
  },
  md: {
    text: "text-base",
    checkbox: "w-5 h-5",
  },
  lg: {
    text: "text-lg",
    checkbox: "w-6 h-6",
  },
}

export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "lg",
      validator: (value) => sizeList.includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Function,
      default: null,
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    sizeClasses() {
      return sizeClassMap[this.size] || sizeClassMap.lg;
    },
  },
  methods: {
    async handleChange(event) {
      const newValue = event.target.checked;
      // Perform validation
      const validationPassed = typeof this.validation === 'function' ? await this.validation(newValue) : true;
      if (validationPassed) {
        // Update state only if validation passes
        this.model = newValue;
      }
      event.target.checked = this.model;
    }
  },
}
</script>

<style lang="scss" scoped></style>